import { FileLikeObject } from 'ng2-file-upload/ng2-file-upload';

export class BadFile {
    public visible: boolean = true;
    public file: FileLikeObject;
    private filter: any

    constructor(file: FileLikeObject, filter: any) {
      this.file = file;
      this.filter = filter;

      setTimeout(() => {
         this.visible = false;
      }, 5000);
    }

    public get message() : string {
       let msg: string = "";
       switch (this.filter.name) {
         case "queueLimit":
           msg = "Maximum 3 files";
         break;
         case "mimeType":
           msg = "Wrong file type";
         break;
         case "fileSize":
           msg = "Maximum file size is 20MB";
         break;
         case "duration":
           msg = "Maximum duration is 60 seconds";
         break;
       }
       return msg;
     }
  }


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/upload/badfile.ts